import { useReducer } from 'react';
import type { OnFilterChange, OnTableChange, OnRoleChange, OnTextChange } from '../../common/types';
import { RESET_PARAMS } from './constants';
import type { Props, State, FilterControllerAction } from './types';

const defaultPageParameters = {
	pageNumber: 1,
	pageSize: 100,
} as const;

export const filterReducer = (state: State, action: FilterControllerAction): State => {
	// Check whether page numb er should be reset
	const { type } = action;
	// @ts-expect-error - TS2345 - Argument of type 'keyof FilterState | keyof TableState' is not assignable to parameter of type 'ResetParam'.
	if (RESET_PARAMS.indexOf(type) !== -1) {
		// Page Number need to be reset
		return {
			...state,
			[action.type]: action.value,
			...defaultPageParameters,
		};
	}
	return {
		...state,
		[action.type]: action.value,
	};
};

export const initialState: State = {
	searchText: '',
	roleType: [],
	roleIds: [],
	orderField: 'NAME',
	orderDirection: 'ASC',
	...defaultPageParameters,
};

const FilterController = (props: Props) => {
	// @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
	const [state, dispatchFilterChange] = useReducer<State, FilterControllerAction>(
		filterReducer,
		initialState,
	);
	const { children } = props;

	const onFilterChange: OnFilterChange = (key, value): void =>
		// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
		dispatchFilterChange({ type: key, value });

	const onTableChange: OnTableChange = (key, value): void =>
		// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
		dispatchFilterChange({ type: key, value });

	const onRoleChange: OnRoleChange = (key, value): void =>
		// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
		dispatchFilterChange({ type: key, value });

	const onTextChange: OnTextChange = (value): void =>
		// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
		dispatchFilterChange({ type: 'searchText', value });

	return children({
		defaultFilters: initialState,
		filters: state,
		onFilterChange,
		onTableChange,
		onRoleChange,
		onTextChange,
	});
};

export default FilterController;
